import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53808)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0009 19.5407H0.000976562V9.4832C0.000976562 9.00713 0.387011 8.62109 0.863084 8.62109H49.1389C49.6149 8.62109 50.001 9.00713 50.001 9.4832L50.0009 19.5407Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1388 41.3795H0.863084C0.387011 41.3795 0.000976562 40.9934 0.000976562 40.5174V30.46H50.0009V40.5174C50.0009 40.9935 49.6148 41.3795 49.1388 41.3795Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0009 19.54H0.000976562V30.459H50.0009V19.54Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.7181 33.1335C12.4629 32.9869 6.46631 29.4991 6.46631 24.1381V16.8105H19.3973V24.1381C19.3973 29.4991 13.4008 32.9869 13.1456 33.1335L12.9318 33.2554L12.7181 33.1335Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.3183 22.8449L14.2862 23.1126H13.609V21.8999H14.0153L15.6409 22.1676L15.4208 21.2226L15.6409 20.2775L14.0153 20.5451H13.609V20.1355L13.8766 18.1035L12.9316 18.3788L11.9867 18.1035L12.2543 20.1355V20.5451H11.8477L10.2223 20.2775L10.4424 21.2226L10.2223 22.1676L11.8477 21.8999H12.2543V23.1126H11.5769L9.54492 22.8449L9.82012 23.7898L9.54492 24.7348L11.5769 24.4672H12.2543V27.5863H13.609V24.4672H14.2862L16.3183 24.7348L16.0432 23.7898L16.3183 22.8449Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.932 26.293C12.0416 26.293 11.2779 26.8332 10.9494 27.6034C10.8914 27.5986 10.8359 27.586 10.7769 27.586C9.6293 27.586 8.7001 28.4854 8.63428 29.6164C10.3799 31.7652 12.5663 33.0457 12.7183 33.1331L12.932 33.2552L13.1458 33.1331C13.2977 33.0457 15.4842 31.7653 17.2298 29.6164C17.1639 28.4854 16.2348 27.586 15.0872 27.586C15.0281 27.586 14.9726 27.5986 14.9146 27.6034C14.5861 26.8332 13.8225 26.293 12.932 26.293Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.9667 17.242C18.9667 17.242 18.9667 22.4144 18.9667 24.1386C18.9667 29.311 12.9322 32.7592 12.9322 32.7592C12.9322 32.7592 6.89775 29.311 6.89775 24.1386C6.89775 22.4144 6.89775 17.242 6.89775 17.242H18.9667ZM19.8287 16.3799H18.9666H6.89775H6.03564V17.242V24.1386C6.03564 29.7468 12.2404 33.3567 12.5045 33.5077L12.9322 33.7521L13.3599 33.5077C13.6241 33.3567 19.8288 29.7467 19.8288 24.1386V17.242V16.3799H19.8287Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53808",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSkFlag);
export { ForwardRef as ReactComponent };
